__turbopack_context__.v({
  "active": "Tab-module-scss-module__V4_Pwa__active",
  "disabled": "Tab-module-scss-module__V4_Pwa__disabled",
  "icon": "Tab-module-scss-module__V4_Pwa__icon",
  "tab": "Tab-module-scss-module__V4_Pwa__tab",
  "template-wrapper": "Tab-module-scss-module__V4_Pwa__template-wrapper",
});
